<template>
    <div class="kv-collapse-search" :class="{ 'kv-active': isActive || internalNoCollapse }">
        <span class="search-button" @click="toggleSearch">
            <Icon icon-class="ui-search-01" size="2" />
        </span>
        <!-- i18n-validator-ignore-next-line: blank placeholder for styling purposes -->
        <input v-model="searchValue" @input="emitValue" type="text" placeholder=" " class="kv-search-field" />
        <span class="kv-placeholder">{{ placeholder }}</span>
    </div>
</template>
<style lang="scss" scoped>
/* SEARCH */
.kv-search {
    position: relative;

    .kv-search-field {
        width: 100%;
        padding-left: 40px;
        color: #1f2a37;
    }
}

.kv-collapse-search {
    position: relative;
    overflow: hidden;
    display: inline-block;
    width: 40px;
    transition: ease-in-out 0.3s all;

    .kv-placeholder {
        position: absolute;
        top: 50%;
        left: 40px;
        opacity: 0;
        color: #9ca3af;
        transform: translateY(-50%);
        z-index: 2;
        transition: ease-in-out 0.3s all;
        pointer-events: none;
        white-space: nowrap;
        font-size: 13px;
    }

    // quando tiver texto
    &:has(.kv-search-field:not(:placeholder-shown)) .kv-placeholder {
        display: none;
    }

    &.kv-active {
        width: 280px;

        .kv-placeholder {
            opacity: 1;
        }

        .kv-search-field {
            padding-left: 40px;
            color: #1f2a37;
        }
    }

    .search-button {
        position: absolute;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 40px;
        cursor: pointer;
    }

    .kv-search-field {
        background-color: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 10px;
        height: 40px;
        transition: all ease-in-out 0.3s;
        outline: none;
        font-size: 13px;
        color: transparent;
        width: 100%;
    }
}

/* SEARCH */
</style>

<script>
import KvInput from './kv-input.vue';

export default {
    name: "KvInputSearch",
    props: {
        placeholder: String,
        noCollapse: {
            type: Boolean,
            default: false
        },
        disableCollapseAt: {
            type: [String, Number], // exemplo: 1536
            default: null
        }
    },
    components: {
        KvInput
    },
    data: function () {
        return {
            internalNoCollapse: this.noCollapse,
            isActive: this.noCollapse,
            searchValue: "",
        }
    },
    mounted() {
        this.checkCollapse();

        window.addEventListener("resize", this.checkCollapse);

        const queryFilter = this.$route.query.filter;

        if (queryFilter) {
            try {
                const parsedFilter = JSON.parse(queryFilter);

                if (parsedFilter.search) {
                    this.isActive = true;
                    this.searchValue = parsedFilter.search;
                }
            } catch (error) {
                console.warn('Filtro inválido na URL:', queryFilter, error);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkCollapse);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        checkCollapse() {
            if (!this.disableCollapseAt) return;

            this.internalNoCollapse = window.innerWidth <= parseInt(this.disableCollapseAt);
        },
        toggleSearch() {
            if (this.noCollapse || this.internalNoCollapse) return;
            this.isActive = !this.isActive;
        },
        emitValue() {
            this.$emit("input", this.searchValue); // emite o valor pro pai
        },
    },
};
</script>
